import Immutable from 'seamless-immutable';
import {
  REQUEST_MULTIPLEX,
  RECEIVE_MULTIPLEX,
  FAILURE_MULTIPLEX
} from '../actions/multiplex.actions';

const INITIAL_STATE = Immutable({
  failure: false,
  fetching: false,
  data: null
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
export default function reduce(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_MULTIPLEX:
      return state.merge({
        fetching: true
      });
    case RECEIVE_MULTIPLEX:
      return state.merge({
        fetching: false,
        data: action.payload.data
      });
    case FAILURE_MULTIPLEX:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/multiplex.reducer.js